if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      handleCustomFormValidations() {
        const form = document.querySelector('.form--custom-contact');
    
        if (!form) {
          return true;
        }
    
          let isValid = true;
          let firstErrorElement = null; // Store the first field with an error


          const emailInput = form.querySelector('[type=email]');
          const emailFormRow = emailInput.closest('.form_row');
          const emailErrorElement = emailFormRow ? emailFormRow.querySelector('.fielderror') : null;

          if (!emailInput?.value?.includes('@') && emailErrorElement) {
            emailErrorElement.style.display = 'block'; // Show error message
            isValid = false;
           if (!firstErrorElement) firstErrorElement = emailFormRow;
          } else if (emailErrorElement) {
            emailErrorElement.style.display = 'none'; // Hide error message
          }
        
  
          // Check radio buttons
          form.querySelectorAll('.radio-thumbnail-group').forEach(function(group) {
              const selectedRadio = group.querySelector('input[type="radio"]:checked');
              const formRow = group.closest('.form_row');
              const errorElement = formRow ? formRow.querySelector('.fielderror') : null;
  
              if (!selectedRadio && errorElement) {
                  errorElement.style.display = 'block'; // Show error message
                  isValid = false;
                  if (!firstErrorElement) firstErrorElement = formRow; // Store the first error form row
              } else if (errorElement) {
                  errorElement.style.display = 'none'; // Hide error message
              }
          });
  
          // Check select dropdowns
          form.querySelectorAll('select').forEach(function(select) {
              const selectedValue = select.value;
              const formRow = select.closest('.form_row');
              const errorElement = formRow ? formRow.querySelector('.fielderror') : null;
  
              if (!selectedValue && errorElement) {
                  errorElement.style.display = 'block'; // Show error message
                  isValid = false;
                  if (!firstErrorElement) firstErrorElement = formRow; // Store the first error form row
              } else if (errorElement) {
                  errorElement.style.display = 'none'; // Hide error message
              }
          });
  
          // If there is an error, scroll to the first field with an error
          if (!isValid && firstErrorElement) {
              // Custom scroll function with offset
              scrollToField(firstErrorElement, 100); // 100px offset from the top
            return false;
          }
  
          // If all fields are valid, submit the form
        // if (isValid) {
        //     form.submit();
        // }
  
      // Hide the error message when the user interacts with radio buttons
      document.querySelectorAll('.radio-thumbnail-group input[type="radio"]').forEach(function(radio) {
          radio.addEventListener('change', function() {
              const formRow = radio.closest('.form_row');
              const errorElement = formRow ? formRow.querySelector('.fielderror') : null;
  
              if (errorElement) {
                  errorElement.style.display = 'none'; // Hide error message
              }
          });
      });
  
      // Hide the error message when the user selects a value from the dropdown
      document.querySelectorAll('select').forEach(function(select) {
          select.addEventListener('change', function() {
              const formRow = select.closest('.form_row');
              const errorElement = formRow ? formRow.querySelector('.fielderror') : null;
  
              if (errorElement) {
                  errorElement.style.display = 'none'; // Hide error message
              }
          });
      });
  
      // Function to scroll with an offset
      function scrollToField(element, offset) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
  
          window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
          });
        }

        return true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const validated = this.handleCustomFormValidations();

        if (!validated) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
